import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Box, Flex, Button } from "@mantine/core";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import { ContactListPinned, ContactListBlocked, ContactListSearch } from "./";

import useAppStore from "./contact-list-store";

export default function ContactList() {
  const { t } = useTranslation();
  const { contactView, setContactView } = useAppStore(
    (state) => ({
      contactView: state.contactView,
      setContactView: state.setContactView,
    }),
    shallow
  );

  const views = [
    {
      label: t("user_app:contact_list_pinned_title"),
      value: "pinned",
    },
    {
      label: t("user_app:contact_list_search_title"),
      value: "search",
    },
    {
      label: t("user_app:contact_list_blocked_title"),
      value: "blocked",
    },
  ];

  return (
    <Box p="sm">
      <Flex gap="xs" justify="center">
        {views.map((m, i) => (
          <Button
            size="xs"
            key={i}
            onClick={() => {
              if (m.value === contactView) return;
              setContactView(m.value);
            }}
            variant={contactView === m.value ? "light" : "subtle"}
          >
            {m.label}
          </Button>
        ))}
      </Flex>
      <div>
        {contactView === "search" && (
          <>
            <ContactListSearch />
          </>
        )}
        {contactView === "pinned" && (
          <>
            <ContactListPinned />
          </>
        )}
        {contactView === "blocked" && (
          <>
            <ContactListBlocked />
          </>
        )}
      </div>
    </Box>
  );
}
